

















































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import type { Venda, ItemDaVenda } from '@/models'

type PassoDoDialogo = 'estoque' | 'vitrine' | 'confirmacaoFinal'

@Component
export default class DialogoDeResumoDaVendaComVitrine extends Vue {
	@Prop({ required: true }) venda!: Venda
	@Prop({ type: String, default: 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png' }) imagemPadrao!: string

	mostra = false
	confirmando = false
	passo: PassoDoDialogo = 'vitrine'
	private resolverConfirmacao: ((confirmado: boolean) => void) | null = null

	get itensDeVitrine(): ItemDaVenda[] {
		return (this.venda?.itens || []).filter(item => Boolean(item.selecionadoViaVitrineVirtual))
	}

	get itensDeEstoque(): ItemDaVenda[] {
		return (this.venda?.itens || []).filter(item => !item.selecionadoViaVitrineVirtual)
	}

	get totalEstoque(): number {
		return this.itensDeEstoque.reduce((acc, item) => acc + this.getTotalDoItem(item), 0)
	}

	get totalVitrine(): number {
		return this.itensDeVitrine.reduce((acc, item) => acc + this.getTotalDoItem(item), 0)
	}

	get totalGeral(): number {
		return this.totalEstoque + this.totalVitrine
	}

	get passosVisiveis(): PassoDoDialogo[] {
		const passos: PassoDoDialogo[] = []

		if (this.itensDeEstoque.length > 0) {
			passos.push('estoque')
		}

		if (this.itensDeVitrine.length > 0) {
			passos.push('vitrine')
		}

		passos.push('confirmacaoFinal')

		return passos
	}

	get indiceDoPassoAtual(): number {
		return this.passosVisiveis.indexOf(this.passo)
	}

	get tituloDoPasso(): string {
		switch (this.passo) {
			case 'estoque':
				return 'Itens de Estoque'
			case 'vitrine':
				return 'Itens da Vitrine Virtual'
			case 'confirmacaoFinal':
				return 'Confirmação'
			default:
				return 'Confirmação'
		}
	}

	get textoBotaoEsquerdo(): string {
		return this.indiceDoPassoAtual > 0 ? 'Voltar' : 'Cancelar'
	}

	mostrar() {
		this.passo = this.passosVisiveis[0]
		this.mostra = true
	}

	voltarOuCancelar() {
		if (this.indiceDoPassoAtual > 0) {
			this.voltar()
			return
		}

		this.fechar()
	}

	voltar() {
		const novoIndice = this.indiceDoPassoAtual - 1

		if (novoIndice >= 0) {
			this.passo = this.passosVisiveis[novoIndice]
		}
	}

	avancar() {
		const novoIndice = this.indiceDoPassoAtual + 1

		if (novoIndice < this.passosVisiveis.length) {
			this.passo = this.passosVisiveis[novoIndice]
		}
	}

	async mostrarEEsperarConfirmacao(): Promise<boolean> {
		this.mostrar()
		return await new Promise(resolve => {
			this.resolverConfirmacao = resolve
		})
	}

	fechar() {
		this.mostra = false
		if (this.resolverConfirmacao) {
			this.resolverConfirmacao(false)
			this.resolverConfirmacao = null
		}
	}

	confirmar() {
		this.mostra = false
		if (this.resolverConfirmacao) {
			this.resolverConfirmacao(true)
			this.resolverConfirmacao = null
		}
	}

	getTotalDoItem(item: ItemDaVenda): number {
		return Number(item.preco || 0) * Number(item.quantidade || 0)
	}

	formatarMoeda(valor: number): string {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(valor)
	}

	getNomeDoItem(item: ItemDaVenda): string {
		return item.produto.nome
	}

	getImagemDoProduto(item: ItemDaVenda) {
		if (item.produto.urlImagens && item.produto.urlImagens.length > 0) {
			const imagemPadrao = item.produto.urlImagens.find(imagem => imagem.padrao)
			return imagemPadrao ? imagemPadrao.imagemUrl : this.imagemPadrao
		}
		return this.imagemPadrao
	}

	getTituloDaEtapa(etapa: PassoDoDialogo): string {
		switch (etapa) {
			case 'estoque':
				return 'Estoque'
			case 'vitrine':
				return 'Vitrine'
			case 'confirmacaoFinal':
				return 'Confirmação'
			default:
				return ''
		}
	}
}
